import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Kontakti from './../block/Kontakti'
import Cards1 from './../block/Cards1'
import NalichnikiCards from './../block/NalichnikiCards'
import NalichnikiMateriali from './../block/NalichnikiMateriali'
import Raschet from './../block/Raschet'
import NalichnikiPrimeri from './../block/NalichnikiPrimeri'
import NalichnikiPreimushestva from './../block/NalichnikiPreimushestva'
import NalichnikiOtzivi from './../block/NalichnikiOtzivi'

class Nalichniki extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          list={data?.zachemnalichniki?.list || []}
          title={data?.zachemnalichniki?.title || ``}
          rtext={``}
          margin={`top`}
          cols={`3`}
          bg={`2`}
        />
        <Cards1
          list={data?.proizvnalichniki?.list || []}
          title={data?.proizvnalichniki?.title || ``}
          rtext={data?.proizvnalichniki?.rtext || ``}
          margin={`top`}
          cols={`4`}
          bg={`1`}
          layout={2}
        />
        <NalichnikiCards
          list={data?.katalognalichniki?.list || []}
          title={data?.katalognalichniki?.title || ``}
          rtext={data?.katalognalichniki?.rtext || ``}
          margin={`top`}
          cols={`3`}
          bg={`2`}
          imageSize={{
            width: 346,
            height: 177
          }}
        />
        <NalichnikiMateriali
          title={data?.nalichnikimateriali?.title || ``}
          text={data?.nalichnikimateriali?.text || ``}
          list={data?.nalichnikimateriali?.list || []}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <NalichnikiPrimeri
          title={data?.nalichnikiprimeri?.title || ``}
          list={data?.nalichnikiprimeri?.list || []}
        />
        <NalichnikiPreimushestva
          title={data?.preimlesnic?.title || ``}
          rtext={data?.preimlesnic?.rtext || ``}
          list={data?.preimlesnic?.list || []}
        />
        <NalichnikiOtzivi
          title={data?.reviews?.title || ``}
          list={data?.reviews?.list || []}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Nalichniki.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Nalichniki.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Nalichniki